<template>
  <div>
    <el-card>
      <nav class="out">
        <nav class="input">
          <el-input v-model="search.keyword" size="medium" placeholder="名称/摘要/行业/标签" clearable />
        </nav>
        <nav class="input" style="width: 150px">
          <el-select v-model="search.categoryId" placeholder="分类" size="medium" clearable>
            <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </nav>
        <nav class="input" style="width: 150px">
          <el-select v-model="search.industryId" placeholder="行业标签" size="medium" clearable>
            <el-option v-for="item in industryList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </nav>
        <nav class="input" style="width: 150px">
          <el-select :multiple-limit="2" v-model="search.operationTagId" placeholder="运营标签" size="medium" clearable>
            <el-option v-for="item in tagList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </nav>
        <nav class="input" style="width: 150px">
          <el-select v-model="search.joinType" placeholder="加入类型" size="medium" clearable>
            <el-option label="免费" :value="1" />
            <el-option label="开通VIP" :value="2" />
            <el-option label="付费" :value="3" />
          </el-select>
        </nav>

        <nav class="input" style="width: 150px">
          <el-select v-model="search.publishStatus" placeholder="上下架" size="medium" clearable>
            <el-option label="下架" :value="0" />
            <el-option label="上架" :value="1" />
          </el-select>
        </nav>
        <nav class="input" style="width: 150px">
          <el-select v-model="search.hot" placeholder="热门" size="medium" clearable>
            <el-option label="否" :value="0" />
            <el-option label="是" :value="1" />
          </el-select>
        </nav>
        <nav class="input" style="width: 150px">
          <el-select v-model="search.recommend" placeholder="推荐" size="medium" clearable>
            <el-option label="否" :value="0" />
            <el-option label="是" :value="1" />
          </el-select>
        </nav>
        <nav class="input">
          <el-button size="small" @click="reset">重置</el-button>
          <el-button type="primary" size="small" @click="submitSearch">{{ btn ? '搜索' : 'loading..' }}</el-button>
          <el-button v-hasShow="'community_list_add'" type="primary" size="small" @click="handleAdd">新增社群</el-button>
        
        </nav>
      </nav>
    </el-card>

    <el-card style="margin-top: 10px">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        stripe
        :header-cell-style="rowClass"
      >
        <el-table-column prop="id" width="70" label="编号" />
        <el-table-column label="主图" width="150">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.banner"
              style="width: 100px"
              :src=" row.banner"
              :preview-src-list="[ row.banner]"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="140" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <p>{{ row.name }}</p>
            <p
              
              style="color: tan; cursor: pointer"
              @click="toMemberList(row)"
            >
              成员列表
            </p>
             <p>
              {{row.memberCount}}人
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="summary" label="摘要" min-width="160" show-overflow-tooltip />
        <el-table-column prop="categoryName" label="分类" width="100" />
        <el-table-column label="行业标签" width="160">
          <template slot-scope="{ row }">
            <template v-if="getIndustryNames(row).length">
              <el-tag
                v-for="(name, index) in getIndustryNames(row)"
                :key="index"
                size="small"
                type="info"
              >
                {{ name }}
              </el-tag>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="运营标签" width="120">
          <template slot-scope="{ row }">
            <el-tag v-if="row.operationTagName" size="small" type="success">
              {{ row.operationTagName }}
            </el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="joinType" label="加入类型" width="100">
          <template slot-scope="{ row }">
           <div>
            <p>
               {{ joinTypeText(row.joinType) }}
            </p>
            <p v-if="row.joinType ==  3">
￥{{ row.price }}
            </p>
            </div>
          </template>
        </el-table-column>
         <el-table-column prop="views" label="浏览量" width="100" />
        <el-table-column prop="sort" align="right" width="100">
          <template #header>
            <span>排序</span><br />
            <span style="font-size: 12px">（当前最大值：{{ orderMax }}）</span>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">数值越大，显示越靠前</div>
              <i class="el-icon-warning-outline" style="margin-left: 5px" />
            </el-tooltip>
          </template>
          <template slot-scope="{ row }">
            <template v-if="$store.state.btn_if.indexOf('community_list_sort') != -1">
              <div class="input-box">
                <el-input
                  v-show="sortEditId === row.id"
                  v-model="row.sort"
                  size="small"
                  class="id"
                  @blur="handleSortBlur(row)"
                />
              </div>
              <span v-show="sortEditId !== row.id" class="el-icon-edit" @click="showSortInput(row.id)">
                {{ row.sort }}
              </span>
            </template>
            <span v-else>{{ row.sort }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="{ row }">
            <el-tag v-if="row.publishStatus == 1" type="success" size="small">上架</el-tag>
            <el-tag v-else type="info" size="small">下架</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="标识" width="100">
          <template slot-scope="{ row }">
            <el-tag v-if="row.hot == 1" type="warning" size="small">热门</el-tag>
            <el-tag v-if="row.recommend == 1" type="warning" size="small">推荐</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="activityTitle" label="关联活动" min-width="180" show-overflow-tooltip />

        <el-table-column prop="creatorName" label="创建人" width="100" />
       
        <el-table-column prop="createTime" label="创建时间" width="160" />
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              v-hasShow="'community_list_edit'"
              type="text"
              icon="el-icon-edit"
              size="mini"
              class="skyblue"
              @click="handleEdit(row.id)"
            >编辑</el-button>
            <el-button
              v-hasShow="'community_list_delete'"
              type="text"
              icon="el-icon-delete"
              size="mini"
              class="red"
              @click="handleDelete(row.id)"
            >删除</el-button>
            <el-button
              v-hasShow="'community_list_publish'"
              type="text"
              icon="el-icon-s-promotion"
              size="mini"
              class="green"
              @click="handlePublish(row)"
            >{{ row.publishStatus == 0 ? '上架' : '下架' }}</el-button>
            <el-button
              v-hasShow="'community_list_hot'"
              type="text"
              icon="iconfont icon-remen"
              size="mini"
              class="a4"
              @click="handleHot(row)"
            >&nbsp;{{ row.hot == 1 ? '取消热门' : '热门' }}</el-button>
            <el-button
              v-hasShow="'community_list_top'"
              type="text"
              icon="el-icon-share"
              size="mini"
              class="a5"
              @click="handleRecommend(row)"
            >{{ row.recommend == 1 ? '取消推荐' : '推荐' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :current-page="search.page"
          background
          :page-size="search.pageSize"
          layout="total, prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

  </div>
</template>

<script>
export default {
  name: 'CommunityList',
  data() {
    return {
      btn: true,
      tableData: [],
      total: 0,
      orderMax: 0,
      categoryList: [],
      industryList: [],
      tagList: [],
      baseurl: this.$store.state.env.cdnImg,
      yu: '/' + this.$store.state.env.domain,
      search: {
        keyword: '',
        categoryId: '',
        industryId: '',
        operationTagId: '',
        joinType: '',
        publishStatus: '',
        hot: '',
        recommend: '',
        page: 1,
        pageSize: 10
      },
      queryParams: {},
      sortEditId: null
    }
  },
  created() {
    this.loadOptions()
    this.getlist()
  },
  activated() {
    this.getlist()
  },
  methods: {
    joinTypeText(val) {
      const map = { 1: '免费', 2: '开通VIP', 3: '付费' }
      return map[val] || '-'
    },
    getIndustryNames(row) {
      if (row.industries && row.industries.length) {
        return row.industries.map((item) => item.name).filter(Boolean)
      }
      if (row.industryName) {
        return String(row.industryName)
          .split(/[、,，]/)
          .map((item) => item.trim())
          .filter(Boolean)
      }
      return []
    },
    rowClass() {
      return 'background:#F5F7FA;'
    },
    getQueryParams() {
      const params = { ...this.search }
      ;['categoryId', 'industryId', 'operationTagId', 'joinType', 'publishStatus', 'hot', 'recommend'].forEach((key) => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key]
        }
      })
      if (!params.keyword) delete params.keyword
      return params
    },
    async loadOptions() {
      const fetchList = async (url) => {
        try {
          const { data: res } = await this.$http.get(url, { params: { page: 1, pageSize: 1000 } })
          if (res.errorCode == 200) return res.data.list || []
        } catch (e) {
          return []
        }
        return []
      }
      const [categoryList, industryList, tagList] = await Promise.all([
        fetchList('/admin/CommunityCategory/getList'),
        fetchList('/admin/CommunityIndustry/getList'),
        fetchList('/admin/CommunityOperationTag/getList')
      ])
      this.categoryList = categoryList
      this.industryList = industryList
      this.tagList = tagList
    },
    getlist() {
      const params = Object.keys(this.queryParams).length ? { ...this.queryParams } : this.getQueryParams()
      this.$http
        .get('/admin/Community/getList', { params })
        .then(({ data: res }) => {
          if (res.errorCode == 200) {
            this.tableData = res.data.list || []
            this.total = res.data.totalCount || 0
            this.orderMax = res.data.orderMax || 0
            this.btn = true
          }
        })
    },
    submitSearch() {
      if (!this.btn) return
      this.btn = false
      this.search.page = 1
      this.queryParams = this.getQueryParams()
      this.getlist()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.loadOptions()
      this.queryParams = {}
      this.getlist()
    },
    handleCurrentChange(page) {
      this.search.page = page
      this.queryParams = { ...this.getQueryParams(), page }
      this.getlist()
    },
    handleAdd() {
      this.$router.push('/community_add')
    },
    toMemberList(row) {
      this.$router.push({
        path: '/community_member_list',
        query: { id: row.id }
      })
    },
    handleEdit(id) {
      this.$router.push({
        path: '/community_add',
        query: { id }
      })
    },
    handleDelete(id) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http
            .delete('/admin/Community/del', { params: { id } })
            .then(({ data: res }) => {
              if (res.errorCode == 200) {
                this.$message.success(res.message)
                if (this.total % this.search.pageSize == 1 && this.search.page > 1) {
                  this.search.page--
                  this.queryParams.page = this.search.page
                }
                this.getlist()
              }
            })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    handlePublish(row) {
      const publishStatus = row.publishStatus == 1 ? 0 : 1
      const actionText = publishStatus == 1 ? '上架' : '下架'
      this.$confirm(`确认${actionText}该社群？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http
            .post('/admin/Community/publish', { id: row.id, publishStatus })
            .then(({ data: res }) => {
              if (res.errorCode == 200) {
                this.$message.success(res.message)
                this.getlist()
              }
            })
        })
        .catch(() => {})
    },
    handleHot(row) {
      const hot = row.hot == 1 ? 0 : 1
      this.$http.post('/admin/Community/hot', { id: row.id, hot }).then(({ data: res }) => {
        if (res.errorCode == 200) {
          this.$message.success(res.message)
          this.getlist()
        }
      })
    },
    handleRecommend(row) {
      const recommend = row.recommend == 1 ? 0 : 1
      this.$http.post('/admin/Community/recommend', { id: row.id, recommend }).then(({ data: res }) => {
        if (res.errorCode == 200) {
          this.$message.success(res.message)
          this.getlist()
        }
      })
    },
    showSortInput(id) {
      this.sortEditId = id
      this.$nextTick(() => {
        $('.id input').focus()
      })
    },
    handleSortBlur(row) {
      this.$http
        .post('/admin/Community/sort', { id: row.id, sort: row.sort })
        .then(({ data: res }) => {
          if (res.errorCode == 200) {
            this.$message.success(res.message)
            this.sortEditId = null
            this.getlist()
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
.out {
  margin-bottom: 20px;
  .input {
    width: 37%;
    display: inline-block;
    margin-right: 30px;
  }
}
.skyblue {
  color: skyblue;
}
.green {
  color: green;
}
.red {
  color: red;
}
.a4 {
  color: #f96535;
}
.a5 {
  color: #ae09b5;
}
.el-tag {
  margin: 2px;
}
</style>
